import { ResidualsUserRole } from "globalConstants";
import {
	hasPermissions,
	permissionList,
	residualsUserPermissionSet,
} from "helpers";

export const USER_ROLES = {
	AgentOfficeAdmin: "Agent office admin",
	AgentOfficeManager: "Agent office manager",
	AgentRelations: "Agent Relations",
	Boarding: "Boarding",
	Custom: "Custom",
	CustomerService: "Customer Service",
	DirectorAgentRelations: "Director Agent Relations",
	DirectorBoarding: "Director Boarding",
	DirectorCustomerService: "Director Customer Service",
	DirectorRiskCredit: "Director Risk/Credit",
	DirectorFinance: "Director Finance",
	DirectorTechSupport: "Director Tech Support",
	Executive: "Executive",
	Finance: "Finance",
	InsideSales: "Inside Sales",
	InsideSaleManagerBusinessDevelopment:
		"Inside Sales Manager/Business Development",
	OutsideAgent: "Outside Agent",
	ReferralPartner: "Referral Partner",
	RiskAnalystUnderwriter: "Risk Analyst/Underwriter",
	TechSupport: "Tech Support",
	ResidualsUser: ResidualsUserRole,
};

export const USER_GROUPS = {
	InternalSalesAgent: {
		name: "InternalSalesAgent",
		value: [
			USER_ROLES.InsideSaleManagerBusinessDevelopment,
			USER_ROLES.InsideSales,
		],
	},
	Ops: {
		name: "Ops",
		value: [
			USER_ROLES.CustomerService,
			USER_ROLES.TechSupport,
			USER_ROLES.Boarding,
			USER_ROLES.AgentRelations,
		],
	},
	ExternalAgentPartner: {
		name: "ExternalAgentPartner",
		value: [
			USER_ROLES.AgentOfficeManager,
			USER_ROLES.AgentOfficeAdmin,
			USER_ROLES.OutsideAgent,
			USER_ROLES.ReferralPartner,
		],
	},
	HigherThanOps: {
		name: "HigherThanOps",
		value: [
			USER_ROLES.Executive,
			USER_ROLES.DirectorCustomerService,
			USER_ROLES.DirectorTechSupport,
			USER_ROLES.DirectorBoarding,
			USER_ROLES.DirectorAgentRelations,
			USER_ROLES.RiskAnalystUnderwriter,
			USER_ROLES.DirectorRiskCredit,
		],
	},
	Finance: {
		name: "Finance",
		value: [USER_ROLES.Finance, USER_ROLES.DirectorFinance],
	},
	ResidualsUser: {
		name: "ResidualsUser",
		value: [USER_ROLES.ResidualsUser],
	},
};

export const getUserGroupByRoleName = userRoleName => {
	const userGroup = Object.values(USER_GROUPS).find(group =>
		group?.value.some(role => role === userRoleName),
	);

	return userGroup?.name;
};

export const hasPermissionsByUserGroup = roleName => {
	switch (getUserGroupByRoleName(roleName)) {
		case USER_GROUPS.InternalSalesAgent.name:
			return hasPermissions(permissionList.AddUserInternalSalesAgent);
		case USER_GROUPS.Ops.name:
			return hasPermissions(permissionList.AddUserOps);
		case USER_GROUPS.ExternalAgentPartner.name:
			return hasPermissions(permissionList.AddUserExternalAgentPartner);
		case USER_GROUPS.HigherThanOps.name:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_GROUPS.Finance.name:
			return hasPermissions(permissionList.AddUserFinance);
		case USER_GROUPS.ResidualsUser.name:
			return hasPermissions(residualsUserPermissionSet);
		default:
			return false;
	}
};

export const hasPermissionsByUserGroupForHistory = roleName => {
	switch (roleName) {
		case USER_ROLES.Finance:
			return hasPermissions(permissionList.AddUserFinance);
		case USER_ROLES.DirectorFinance:
			return hasPermissions(permissionList.AddUserFinance);
		case USER_ROLES.InsideSaleManagerBusinessDevelopment:
			return hasPermissions(permissionList.AddUserInternalSalesAgent);
		case USER_ROLES.InsideSales:
			return hasPermissions(permissionList.AddUserInternalSalesAgent);
		case USER_ROLES.RiskAnalystUnderwriter:
			return hasPermissions(permissionList.AddUserOps);
		case USER_ROLES.CustomerService:
			return hasPermissions(permissionList.AddUserOps);
		case USER_ROLES.TechSupport:
			return hasPermissions(permissionList.AddUserOps);
		case USER_ROLES.Boarding:
			return hasPermissions(permissionList.AddUserOps);
		case USER_ROLES.AgentRelations:
			return hasPermissions(permissionList.AddUserOps);
		case USER_ROLES.AgentOfficeManager:
			return hasPermissions(permissionList.AddUserExternalAgentPartner);
		case USER_ROLES.AgentOfficeAdmin:
			return hasPermissions(permissionList.AddUserExternalAgentPartner);
		case USER_ROLES.OutsideAgent:
			return hasPermissions(permissionList.AddUserExternalAgentPartner);
		case USER_ROLES.ReferralPartner:
			return hasPermissions(permissionList.AddUserExternalAgentPartner);
		case USER_ROLES.Executive:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_ROLES.DirectorCustomerService:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_ROLES.DirectorTechSupport:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_ROLES.DirectorBoarding:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_ROLES.DirectorAgentRelations:
			return hasPermissions(permissionList.AddUserHtOps);
		case USER_ROLES.DirectorRiskCredit:
			return hasPermissions(permissionList.AddUserHtOps);
		default:
			return false;
	}
};
